'use strict';

var intellidealerAppAlertsModule = angular.module('intellidealerApp.alerts', ['intellidealerApp.core']);
